module.exports = __webpack_public_path__ + "fonts/unicredit-mediumitalic.98137001.eot";